import actions from './actions';

const generateOffRampPageLink = (offRampId) => `/off-ramps/${offRampId}`;

export const pageSizeOptions = [10, 25, 50];
export const defaultPageSize = 10;

export const actionsMap = {
  nextPage: actions.offRampsTableNextPage,
  onOffRampIdClick: generateOffRampPageLink,
  previousPage: actions.offRampsTablePreviousPage,
  resetPage: actions.resetOffRampsTablePage,
  setFilter: actions.setOffRampsTableFilter,
  setPage: actions.setOffRampsTablePage,
  setSort: actions.setOffRampsTableSort,
};
